export default {
  loading: {
    id: 'bo_seller-homepage-loading',
    defaultMessage: 'Loading...',
  },
  title: {
    id: 'bo_seller-homepage-customer_reviews_title',
    defaultMessage: 'Customer reviews',
  },
  description: {
    id: 'bo_seller-homepage-customer_reviews_description',
    defaultMessage: 'Customer reviews over the last 24 months.',
  },
  seeReviewsButton: {
    id: 'merchant_home_page_user_reviews_block_see_reviews_button',
    defaultMessage: 'Customer reviews',
  },
  noUsersReviews: {
    id: 'merchant_home_page_user_reviews_block_no_users_reviews',
    defaultMessage: 'No customer reviews yet.',
  },
}
